<section class="form-wrapper">
  <mat-card appearance="outlined" class="form-wrapper__settings">
    <mat-card-header>
      <mat-card-title>Number Ranges</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="number-ranges__toolbar">
        <mat-form-field class="form-wrapper__searchPart">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" #input>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="create()">
          <mat-icon>add</mat-icon> Add Number Range
        </button>
        <button mat-button (click)="load()" matTooltip="Reload">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" matSort>

          <ng-container matColumnDef="key">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Key</th>
            <td mat-cell *matCellDef="let row">{{ row.key }}</td>
          </ng-container>

          <ng-container matColumnDef="min">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Min</th>
            <td mat-cell *matCellDef="let row">{{ row.min }}</td>
          </ng-container>

          <ng-container matColumnDef="max">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Max</th>
            <td mat-cell *matCellDef="let row">{{ row.max }}</td>
          </ng-container>

          <ng-container matColumnDef="actual">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Actual</th>
            <td mat-cell *matCellDef="let row">{{ row.actual }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row" class="number-ranges__actions">
              <button mat-icon-button matTooltip="Increment" (click)="increment(row)" [disabled]="row.actual >= row.max">
                <mat-icon>exposure_plus_1</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Edit" (click)="edit(row)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button matTooltip="Delete" (click)="delete(row)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <tr class="mat-row" *matNoDataRow>
            @if (!loading) {
              <td class="mat-cell" colspan="5">No number ranges matching the filter "{{ input.value }}"</td>
            }
          </tr>
        </table>
        @if (loading) {
          <div class="form-wrapper__table-loading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <mat-paginator [pageSizeOptions]="[12, 25, 100]"></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</section>
